import { watchBlocks } from '@wagmi/core'
import { wagmiConfig } from '@/config/wagmi-config'
import type { OnBlockParameter } from 'viem'

/**
 * Resolves when the specified number of blocks have been mined
 *
 * @param blocks - Number of blocks to wait for. Default is 1
 * @returns Promise that resolves when the last block is mined
 */
export function waitForNextMinedBlocks(blocks = 1) {
	return new Promise<OnBlockParameter>((resolve, reject) => {
		let counter = 0

		const unwatch = watchBlocks(wagmiConfig, {
			blockTag: 'latest',
			onBlock: async args => {
				// Ensure that the block has transactions
				if (args.transactions.length > 0 && ++counter >= blocks) {
					try {
						resolve(args)
					} catch (error) {
						reject(error)
					} finally {
						unwatch()
					}
				}
			}
		})
	})
}
